import { createContext } from "react";

const adminemailLogsContext = createContext();

export default adminemailLogsContext;
